import axios from 'axios';
import { createHaulingContractQuery } from './queries';

const addHaulingContract = (model) =>
    new Promise((resolve, reject) => {
        const query = createHaulingContractQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add hauling contract'));
            });
    });

export default addHaulingContract;
